import React from 'react';
import { Link } from 'react-router-dom';

const Landing: React.FC = () => {
  const features = [
    {
      icon: '�',
      title: 'Beleg-Scanner',
      description: 'Fotografiere deine Belege und lass sie automatisch per OCR auslesen – Betrag und Händler werden erkannt'
    },
    {
      icon: '💰',
      title: 'Intelligentes Tagesbudget',
      description: 'Berechnet automatisch dein verfügbares Budget basierend auf deinem echten Gehaltszyklus – nicht starr monatlich'
    },
    {
      icon: '🔒',
      title: 'Verschlüsselt & privat',
      description: 'Alle sensiblen Daten werden verschlüsselt gespeichert – nur du kannst deine Kontostände und Transaktionen sehen'
    },
    {
      icon: '🎯',
      title: 'Schuldenmanagement',
      description: 'Verwalte Kredite und Raten mit Zahlungsverlauf, automatischer Tilgungsberechnung und Rollback-Funktion'
    },
    {
      icon: '🔔',
      title: 'Fixkosten-Tracker',
      description: 'Miete, Abos, Versicherungen – bestätige wiederkehrende Zahlungen und behalte den Überblick'
    },
    {
      icon: '⚡',
      title: 'Flexibel & personalisiert',
      description: 'Schließe Sparkonten oder bestimmte Schulden vom Budget aus – du entscheidest, was zählt'
    },
    {
      icon: '📱',
      title: 'Mobile-first Design',
      description: 'Optimiert für Smartphones – nutze es überall, wo du bist'
    }
  ];

  const isMobile = window.innerWidth <= 768;

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0f2027 0%, #203a43 50%, #2c5364 100%)',
      color: 'white'
    }}>
      {/* Header */}
      <header style={{
        padding: isMobile ? '15px 20px' : '20px 40px',
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        justifyContent: 'space-between',
        alignItems: isMobile ? 'flex-start' : 'center',
        gap: isMobile ? '15px' : '0'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <h1 style={{
            margin: 0,
            fontSize: isMobile ? '22px' : '28px',
            fontWeight: 'bold',
            transform: 'rotate(-2deg)',
            transition: 'transform 0.3s ease'
          }}>
            MeineGroschen
          </h1>
          <span style={{
            background: 'rgba(255, 255, 255, 0.2)',
            color: 'white',
            padding: '4px 10px',
            borderRadius: '6px',
            fontSize: '12px',
            fontWeight: 'bold',
            border: '1px solid rgba(255, 255, 255, 0.3)'
          }}>
            BETA
          </span>
        </div>
        <div style={{ display: 'flex', gap: isMobile ? '10px' : '0', width: isMobile ? '100%' : 'auto' }}>
          <Link
            to="/login"
            style={{
              color: 'white',
              textDecoration: 'none',
              marginRight: isMobile ? '0' : '20px',
              padding: isMobile ? '10px 15px' : '10px 20px',
              borderRadius: '8px',
              transition: 'background 0.3s ease',
              flex: isMobile ? '1' : 'none',
              textAlign: 'center',
              fontSize: isMobile ? '14px' : '16px'
            }}
            onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)'}
            onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
          >
            Anmelden
          </Link>
          <Link
            to="/register"
            style={{
              background: 'white',
              color: '#0f2027',
              textDecoration: 'none',
              padding: isMobile ? '10px 15px' : '10px 25px',
              borderRadius: '8px',
              fontWeight: 'bold',
              transition: 'transform 0.3s ease',
              flex: isMobile ? '1' : 'none',
              textAlign: 'center',
              fontSize: isMobile ? '14px' : '16px'
            }}
            onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
          >
            Registrieren
          </Link>
        </div>
      </header>

      {/* Hero Section */}
      <section style={{
        textAlign: 'center',
        padding: isMobile ? '40px 20px' : '80px 20px',
        maxWidth: '900px',
        margin: '0 auto'
      }}>
        <h2 style={{
          fontSize: isMobile ? '32px' : '52px',
          fontWeight: 'bold',
          marginBottom: '20px',
          lineHeight: '1.2'
        }}>
          Mehr als nur ein Haushaltsbuch.<br />Dein persönliches Finanz-Cockpit.
        </h2>
        <p style={{
          fontSize: isMobile ? '16px' : '20px',
          opacity: 0.9,
          marginBottom: '20px',
          lineHeight: '1.6'
        }}>
          MeineGroschen berechnet dein echtes Tagesbudget, scannt Belege automatisch
          und passt sich deinem Gehaltszyklus an – verschlüsselt, intelligent und komplett kostenlos.
        </p>
        <p style={{
          fontSize: isMobile ? '14px' : '16px',
          opacity: 0.8,
          marginBottom: '40px',
          background: 'rgba(255, 255, 255, 0.1)',
          padding: isMobile ? '12px 15px' : '15px 25px',
          borderRadius: '8px',
          display: 'inline-block',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          maxWidth: isMobile ? '100%' : 'auto'
        }}>
          💡 <strong>Wichtig:</strong> MeineGroschen ist ein reines Planungs- und Verwaltungstool ohne Bankverbindung. 
          Es werden keine echten Transaktionen ausgeführt.
        </p>
        <Link
          to="/register"
          style={{
            display: 'inline-block',
            background: 'white',
            color: '#0f2027',
            textDecoration: 'none',
            padding: isMobile ? '14px 30px' : '18px 40px',
            borderRadius: '12px',
            fontSize: isMobile ? '16px' : '18px',
            fontWeight: 'bold',
            boxShadow: '0 8px 20px rgba(0, 0, 0, 0.3)',
            transition: 'all 0.3s ease',
            width: isMobile ? 'calc(100% - 40px)' : 'auto',
            maxWidth: isMobile ? '300px' : 'none'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-4px)';
            e.currentTarget.style.boxShadow = '0 12px 30px rgba(0, 0, 0, 0.4)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.3)';
          }}
        >
          Jetzt kostenlos starten →
        </Link>
      </section>

      {/* Features Grid */}
      <section style={{
        padding: isMobile ? '40px 20px' : '60px 20px',
        maxWidth: '1200px',
        margin: '0 auto'
      }}>
        <h3 style={{
          textAlign: 'center',
          fontSize: isMobile ? '28px' : '36px',
          marginBottom: isMobile ? '30px' : '50px',
          fontWeight: 'bold'
        }}>
          Alles, was du brauchst
        </h3>
        <div style={{
          display: 'grid',
          gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
          gap: isMobile ? '20px' : '30px',
          justifyItems: 'stretch',
          maxWidth: isMobile ? '100%' : '1200px'
        }}>
          {features.map((feature, index) => (
            <div
              key={index}
              style={{
                background: 'rgba(255, 255, 255, 0.1)',
                backdropFilter: 'blur(10px)',
                borderRadius: '16px',
                padding: isMobile ? '25px' : '30px',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                transition: 'all 0.3s ease',
                ...(features.length === 7 && index === 6 && !isMobile ? {
                  gridColumn: '2 / 3',
                  maxWidth: '400px',
                  margin: '0 auto'
                } : {})
              }}
              onMouseEnter={(e) => {
                if (!isMobile) {
                  e.currentTarget.style.transform = 'translateY(-8px)';
                  e.currentTarget.style.background = 'rgba(255, 255, 255, 0.15)';
                }
              }}
              onMouseLeave={(e) => {
                if (!isMobile) {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
                }
              }}
            >
              <div style={{ fontSize: isMobile ? '40px' : '48px', marginBottom: '15px' }}>
                {feature.icon}
              </div>
              <h4 style={{
                fontSize: isMobile ? '20px' : '22px',
                marginBottom: '10px',
                fontWeight: 'bold'
              }}>
                {feature.title}
              </h4>
              <p style={{
                opacity: 0.9,
                lineHeight: '1.6',
                margin: 0,
                fontSize: isMobile ? '14px' : '16px'
              }}>
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section style={{
        textAlign: 'center',
        padding: isMobile ? '40px 20px' : '80px 20px',
        background: 'rgba(0, 0, 0, 0.2)'
      }}>
        <h3 style={{
          fontSize: isMobile ? '28px' : '36px',
          marginBottom: '20px',
          fontWeight: 'bold'
        }}>
          Bereit durchzustarten?
        </h3>
        <p style={{
          fontSize: isMobile ? '16px' : '18px',
          opacity: 0.9,
          marginBottom: '30px'
        }}>
          Registriere dich jetzt kostenlos und behalte deine Finanzen im Blick.
        </p>
        <Link
          to="/register"
          style={{
            display: 'inline-block',
            background: 'white',
            color: '#0f2027',
            textDecoration: 'none',
            padding: isMobile ? '14px 30px' : '16px 35px',
            borderRadius: '12px',
            fontSize: isMobile ? '16px' : '18px',
            fontWeight: 'bold',
            transition: 'all 0.3s ease',
            width: isMobile ? 'calc(100% - 40px)' : 'auto',
            maxWidth: isMobile ? '300px' : 'none'
          }}
          onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
          onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
        >
          Kostenlos registrieren
        </Link>
      </section>

      {/* Footer */}
      <footer style={{
        textAlign: 'center',
        padding: isMobile ? '20px' : '30px 20px',
        opacity: 0.7,
        fontSize: isMobile ? '13px' : '14px',
        borderTop: '1px solid rgba(255, 255, 255, 0.1)'
      }}>
        <Link to="/imprint" style={{ color: 'white', textDecoration: 'none', marginRight: '20px' }}>
          Impressum
        </Link>
        <Link to="/privacy" style={{ color: 'white', textDecoration: 'none' }}>
          Datenschutz
        </Link>
        <p style={{ marginTop: '15px', opacity: 0.6 }}>
          © 2026 MeineGroschen. Alle Rechte vorbehalten.
        </p>
      </footer>
    </div>
  );
};

export default Landing;
